var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260-280v-320h40v320h-40Zm200 0v-320h40v320h-40ZM141.538-160v-40h676.924v40H141.538ZM660-280v-320h40v320h-40ZM141.538-680v-33.846L480-875.385l338.462 161.539V-680H141.538Zm105.693-40h465.538-465.538Zm0 0h465.538L480-830 247.231-720Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalance);
export default __webpack_public_path__ + "static/media/account_balance.a3e2c19cedef11caa96ba14c656e0628.svg";
export { ForwardRef as ReactComponent };